import React from 'react';
import { Navigate } from 'react-router-dom';
import useWebsiteSetupStatus from '../hooks/useWebsiteSetupStatus';
import LoaderCard from '../../shared/LoaderCard';
import AddDomainStep from './AddDomainStep';
import SitemapImportProgress from './SitemapImportProgress';
import AddUrlsManuallyStep from './AddUrlsManuallyStep';
import './Wizard.less';

type Props = {
    websiteGuid?: string;
    onAddDomain: (websiteGuid: string) => void;
};

export default function AddWebsiteIndexEntryWizard({ websiteGuid, onAddDomain }: Props) {
    const { websiteStatus, isLoadingWebsiteStatus, refetchWebsiteStatus } = useWebsiteSetupStatus(websiteGuid);

    const finishAddUrlsManuallyStep = () => {
        refetchWebsiteStatus();
    };

    return (
        <>
            {isLoadingWebsiteStatus && <LoaderCard />}

            {!!websiteStatus && websiteStatus.status === 'importing_sitemaps' && (
                <SitemapImportProgress
                    sitemapUrls={websiteStatus.website.sitemap_urls || []}
                    sitemapStartTime={websiteStatus.import_sitemaps_started_at!}
                />
            )}

            {websiteGuid === undefined && (
                <AddDomainStep
                    loading={isLoadingWebsiteStatus}
                    onFinish={onAddDomain}
                />
            )}

            {!!websiteStatus && websiteGuid && websiteStatus.status === 'waiting_for_user_input' && (
                <AddUrlsManuallyStep
                    websiteGuid={websiteGuid}
                    loading={isLoadingWebsiteStatus}
                    onFinish={finishAddUrlsManuallyStep}
                />
            )}

            {!!websiteStatus && websiteStatus.status === 'completed' && <Navigate to={{ pathname: '/deep-analysis', search: `?w_guid=${websiteGuid}` }} />}
        </>
    );
}
